module.exports = __webpack_public_path__ + "static/media/ice.c389a73b.png";